import { ROUTES } from './constants';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from './services/meta.service';
import { MetaTags } from './models/meta-tags.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  readonly appName = 'upBinar';

  constructor(private router: Router, private metaService: MetaService) {
    const url = this.metaService.getAbsoluteUrl('');

    const metaTags: MetaTags = {
      title: 'The best tech tools webinars | upBinar',
      description:
        'Master remote tools the right way. Watch top rated webinars from great companies.',
      url,
      keywords:
        'webinars, tech, tools, watch, remote, miro, slack, figma, trello',
      image: {
        url: this.metaService.getAbsoluteUrl('/assets/images/share.png'),
        width: 1300,
        height: 732,
      },
    };
    this.metaService.title = metaTags.title;
    this.metaService.updateMetaTags(metaTags);
  }

  goToHome() {
    return this.router.navigate([`/${ROUTES.main.base}`]);
  }
}
